import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import financeData from '../datas/finance'
export default {
  getTaxProjctList (ctx, data) {
    return fetch.getTaxProjctList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = financeData.getTaxProjctList(result.data)
      return result
    })
  },
  creatTaxProject (ctx, data) {
    return fetch.creatTaxProject(data).then(res => {
      let result = res.data
      return result
    })
  },
  getTaxPrejectDetail (ctx, id) {
    return fetch.getTaxPrejectDetail(id).then(res => {
      let result = res.data

      return result
    })
  },
  editTaxProject (ctx, data) {
    return fetch.editTaxProject(data).then(res => {
      let result = res.data
      return result
    })
  },
  deleteTaxProject (ctx, id) {
    return fetch.deleteTaxProject(id).then(res => {
      let result = res.data
      return result
    })
  },
  consultantPaymentOrder (ctx, data) {
    return fetch.consultantPaymentOrder(data).then(res => {
      let result = getTotalNumber(res)
      result.data = financeData.consultantPaymentOrder(result.data)
      return result
    })
  },
  exportConsultantPaymentOrders (ctx, data) {
    return fetch.exportConsultantPaymentOrders(data).then(res => {
      return res.data
    })
  },
  exportLifeExperienceHallPaymentOrders (ctx, data) {
    return fetch.exportLifeExperienceHallPaymentOrders(data).then(res => {
      return res.data
    })
  },
  exportLifeStoragePaymentOrders (ctx, data) {
    return fetch.exportLifeStoragePaymentOrders(data).then(res => {
      return res.data
    })
  },
  refundPaymentOrder (ctx, id) {
    return fetch.refundPaymentOrder(id).then(res => {
      return res.data
    })
  }
}
